import { RadioField, TextField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { isNoTouchDevice } from 'services/touch_device_detection';
import { Base } from './base';
const wrapperCss = "w1rq9mjp";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const CustomInline = ({
  fieldNamePrefix,
  canHideLocation,
  onKeyPress = () => {}
}) => {
  const locationFieldName = `${fieldNamePrefix}.location`;
  const hideLocationFieldName = `${fieldNamePrefix}.hideLocation`;
  return <Base header={I18n.t('publisher.event_type_editor.sections.event_details.location.inlines.custom.header')}>
      <TextField aria-label={I18n.t('publisher.event_types.location.custom_location_label')} autoFocus={isNoTouchDevice()} size="small" name={locationFieldName} onKeyDown={onKeyPress} />
      {canHideLocation && <>
          <Wrapper>
            <BodyText size="medium" weight="bold">
              {I18n.t('publisher.event_type_editor.sections.event_details.location.inlines.custom.hide_location.header')}
            </BodyText>
          </Wrapper>
          <RadioField label={<BodyText size="medium">
                {I18n.t('publisher.event_type_editor.sections.event_details.location.inlines.custom.hide_location.visible_label')}
              </BodyText>} name={hideLocationFieldName} value="visible" />
          <RadioField label={<BodyText size="medium">
                {I18n.t('publisher.event_type_editor.sections.event_details.location.inlines.custom.hide_location.hidden_label')}
              </BodyText>} name={hideLocationFieldName} value="hidden" />
        </>}
    </Base>;
};

require("./custom_inline.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./custom_inline.js");